import { render } from "./SelectPage.vue?vue&type=template&id=1cac027c&ts=true"
import script from "./SelectPage.vue?vue&type=script&lang=ts"
export * from "./SelectPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__